import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import {
  Box,
  Paper,
} from "@mui/material";
import { getNotificationPermission, notificationChannelTypes, notificationListPageSize, notificationStatusHeaders } from "./notificationConstant";
import Alert from "../layout/Alert";
import { selectMenuProps } from "../../utils/selectMenuProps";
import PhoneInput from "react-phone-input-2";
import { format } from "date-fns";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IncrementalPagination from "../Common/DataTable/IncrementalPagination";
import { useTheme } from "@mui/material/styles";
import AppButton from "../Common/Button/Button";
import AppIconButton from "../Common/Button/IconButton";
import { useDesignTokens } from "../../theme/useDesignTokens";
import FormInput from "../Common/FormInputs/MuiTextField";
import DataTable from "../Common/DataTable/DataTable";
import ScreenLoader from "../Common/ScreenLoader/ScreenLoader";
import EmptyState from "../Common/EmptyState/EmptyState";
import { SearchSectionLabel, SectionHeading, LabelText } from "../Common/Typography/AppTypography";




const searchInputHeight = 45;
const defaultBorderColor = "rgba(0, 0, 0, 0.42)";
const filterCardSx = {
  p: 2,
  boxShadow: 2,
  borderRadius: 1,
  overflow: "visible",
  minWidth: 0,
};
const searchCardSx = {
  ...filterCardSx,
  boxShadow: "none",
  border: "none",
};

/** Paper for results: clip children so inner panels cannot extend past rounded corners */
const resultsCardSx = {
  ...filterCardSx,
  overflow: "hidden",
};

const severityOptions = [
    { label: "None", value: null },
    { label: "Info", value: "info" },
    { label: "Alert", value: 'alert' },
    { label: 'Recommendation', value: "recommendation" },
    { label: "Promotion", value: "promotion" }]

const FindNotification = ({ notificationData = {},
    getNotificationTask = () => { },
    searchNotificationsByUserId = () => { },
    searchNotifications = () => { },
    setAlert = () => { },
    allowedCountries,
    userData,
    tenantData,
    setDialog,
    setDialogContents,
    setDialogTab,
    userRoles = []
    //setCustomAlert
}) => {

    let searchOptions = []
    if (getNotificationPermission(userRoles, 'getNotificationList')) {
        searchOptions = [
            { label: "User ID", value: "userId", placeholder: "Enter User ID" },
            { label: "User E-mail ID", value: 'email', placeholder: "Enter User Email ID" },
            { label: 'User Mobile no', value: "mobile", placeholder: "Enter Mobile no without code" }
        ]
    }
    if (getNotificationPermission(userRoles, 'getNotificationTask')) {
        searchOptions = [...searchOptions,
        { label: "Task ID", value: "taskId", placeholder: "Enter Task ID" }
        ]
    }

    // add key value pair for any new column to be added to the table. 
    // Key should be same as the key in the response and value should be what you want the header for the column to be
    const notificationHeaders =
    {
        uniqueId: { label: "Unique Id" },
        // notificationType: { label: "Type" },
        sentAt: { label: "Created At" },
        severity: { label: "Severity" },
        action: { label: "Actions", style: { justifyContent: "start" } }
    }

    const [notificationList, setNotificationList] = useState([]);
    const [taskId, setTaskId] = useState({ value: "", textValue: "" });
    const [showNotificationList, setShowNotificationList] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [searchBy, setSearchBy] = useState(searchOptions[0]?.value)
    const [countryCode, setCountryCode] = useState("91");
    const [searchStr, setSearchStr] = useState("");
    const [tableHeaders, setTableHeaders] = useState({});
    const [pageIndex, setPageIndex] = useState(1);
    const [severityFilter, setSeverityFilter] = useState(null);
    const theme = useTheme();
    const { colors } = useDesignTokens();
    const primaryColor = colors?.primary?.main || theme.palette.primary.main;
    const openDialogSafely = () => {
      if (typeof document !== "undefined" && document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      setDialog(true);
    };
    const focusOutlineSx = {
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: `${primaryColor} !important`,
        borderWidth: "1px",
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: `${primaryColor} !important`,
      },
    };

    const phoneInputSx = {
      width: 54,
      height: `${searchInputHeight}px`,
      minHeight: `${searchInputHeight}px`,
      maxHeight: `${searchInputHeight}px`,
      flexShrink: 0,
      marginRight: 0,
      alignSelf: "stretch",
      overflow: "visible",
      "& .react-tel-input": {
        width: "100%",
        height: `${searchInputHeight}px`,
        minHeight: `${searchInputHeight}px`,
        maxHeight: `${searchInputHeight}px`,
        margin: 0,
        overflow: "visible",
      },
      "& .react-tel-input .form-control": {
        display: "none !important",
        width: "0 !important",
        minWidth: "0 !important",
        height: `${searchInputHeight}px !important`,
        minHeight: `${searchInputHeight}px`,
        borderRadius: "4px 0 0 4px",
        borderRight: "none",
        borderColor: "transparent",
        paddingLeft: "0",
        paddingRight: "0",
        fontSize: "14px",
        color: "transparent",
        backgroundColor: "transparent",
        boxShadow: "none",
        pointerEvents: "none",
      },
      "& .react-tel-input .flag-dropdown": {
        height: `${searchInputHeight}px !important`,
        minHeight: `${searchInputHeight}px !important`,
        maxHeight: `${searchInputHeight}px !important`,
        top: 0,
        margin: 0,
        borderRadius: "4px 0 0 4px",
        border: `1px solid ${defaultBorderColor} !important`,
        backgroundColor: "background.paper",
        width: "54px",
        boxSizing: "border-box",
        zIndex: 2,
        position: "relative",
        overflow: "visible",
      },
      "& .react-tel-input .flag-dropdown.open": {
        border: `1px solid ${primaryColor} !important`,
      },
      "& .react-tel-input .flag-dropdown.open .selected-flag": {
        position: "relative",
        zIndex: 3,
        borderRight: `1px solid ${primaryColor}`,
        borderBottom: `1px solid ${primaryColor}`,
      },
      "& .react-tel-input .selected-flag": {
        height: `${searchInputHeight}px`,
        width: "54px",
        padding: "0 0 0 10px",
      },
      "& .react-tel-input .selected-flag:hover": {
        backgroundColor: "transparent !important",
      },
      "& .react-tel-input .country-list": {
        border: `1px solid ${defaultBorderColor}`,
        backgroundColor: "#fff",
        boxSizing: "border-box",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
        marginTop: 2,
        marginLeft: 0,
        zIndex: 3,
      },
    };

    const searchNotificationData = (pg, severity = null) => {
        switch (searchBy) {
            case "userId":
                searchNotificationsByUserId(searchStr, pg, severity)
                break;
            case "mobile":
            case "email":
                if (userData?.user?.userId) {
                    searchNotificationsByUserId(userData.user.userId, pg, severity)
                }
                break;
            default:
                break;
        }
    }

    const getNextPage = () => {
        const newPg = pageIndex + 1
        setPageIndex(newPg);
        searchNotificationData(newPg, severityFilter);
    }

    const getPrevPage = () => {
        const newPg = pageIndex - 1;
        setPageIndex(newPg);
        searchNotificationData(newPg, severityFilter);
    }

    const validateSearchValue = () => {
        if (searchBy === "email" && !/\S+@\S+\.\S+/.test(searchStr)) {
            setShowNotificationList(false);
            setAlert(("Please enter a valid E-mail ID") + ` - User ${searchBy}: ` + searchStr, "danger");
            return false;
        }

        if (searchBy === "mobile" && !/^[0-9]{6,14}$/.test(searchStr)) {
            setShowNotificationList(false);
            setAlert(("Please enter a valid mobile no") + ` - User ${searchBy}: ` + searchStr, "danger");
            return false;
        }

        if (searchBy === "userId") {
            const trimmed = searchStr?.trim() || "";
            if (trimmed.length < 6 || /\s/.test(trimmed)) {
                setShowNotificationList(false);
                setAlert(("Please enter a valid User ID") + ` - User ${searchBy}: ` + searchStr, "danger");
                return false;
            }
        }

        if (searchBy === "taskId") {
            const trimmed = taskId?.textValue?.trim() || "";
            if (trimmed.length < 6 || /\s/.test(trimmed)) {
                setShowNotificationList(false);
                setAlert("Please enter a valid Task ID", "danger");
                return false;
            }
        }

        return true;
    }

    const onSubmit = (e) => {
        e?.preventDefault();

        if (searchBy === "taskId") {
            if (!taskId?.textValue?.trim()) {
                setShowNotificationList(false);
                setAlert("Task ID Cannot be Empty", "danger");
                return;
            }
        } else if (!searchStr?.trim()) {
            setShowNotificationList(false);
            const emptyMessageBySearch = {
                userId: "User ID Cannot be Empty",
                email: "User Email ID Cannot be Empty",
                mobile: "Mobile Number Cannot be Empty",
            };
            setAlert(emptyMessageBySearch[searchBy] || "Search value cannot be empty", "danger");
            return;
        }

        if (!validateSearchValue()) {
            return;
        }

        setPageIndex(1);
        setNotificationList([]);
        setShowNotificationList(true);
        setIsSearching(true);

        switch (searchBy) {
            case "userId":
                searchNotificationsByUserId(searchStr)
                break;
            case "taskId":
                getNotificationTask(taskId?.textValue);
                break;
            case "mobile":
                searchNotifications(searchBy, `+${countryCode}${searchStr}`, 1, tenantData?.tenantId)
                break;
            case "email":
                searchNotifications(searchBy, searchStr, 1, tenantData?.tenantId)
                break;
            default:
                break;
        }
    }
    useEffect(() => {
        if (showNotificationList) {
            if (notificationData?.lastAction?.includes("get_notification_task") && taskId?.textValue !== "" && notificationData?.lastAction?.includes(taskId?.textValue)) {
                // dont remove second and third condititon-check after setTimeout call from previous page is executed and get empty data after data is populated in table
                const hasTaskData = notificationData?.notificationDetails && JSON.stringify(notificationData?.notificationDetails) !== "{}";
                if (hasTaskData) {
                    setNotificationList([{
                        fullTaskId: notificationData?.notificationDetails?.taskId,
                        taskId: <div title={notificationData?.notificationDetails?.taskId}>
                            {
                                "..." + notificationData?.notificationDetails?.taskId?.slice(notificationData?.notificationDetails?.taskId?.length - 6, notificationData?.notificationDetails?.taskId?.length)
                            }
                        </div>,
                        userCount: <div title="The expected number of users that will receive the  notification.">
                            {
                                notificationData?.notificationDetails?.status?.notificationProcessStatus?.userSentCount
                            }
                        </div>,
                        expectedUserCount: <div title={"The number of users that received the notification."}>
                            {
                                notificationData?.notificationDetails?.status?.taskProcessStatus?.userCount + notificationData?.notificationDetails?.status?.taskProcessStatus?.userFailedCount
                            }
                        </div>,
                        taskStatus: notificationData?.notificationDetails?.status?.taskStatus,
                        failureCount: <div title="The number of users the notification failed to reach.">
                            {notificationData?.notificationDetails?.status?.notificationProcessStatus?.failedUserSentCount + notificationData?.notificationDetails?.status?.notificationProcessStatus?.tokenNotFoundUserCount + notificationData?.notificationDetails?.status?.taskProcessStatus?.userFailedCount
                            }
                        </div>,
                        notificationType: notificationChannelTypes[notificationData?.notificationDetails?.channel?.type + "Notification"]?.label,
                        severity: notificationData?.notificationDetails?.severity,
                        createdAt: format(new Date(notificationData?.notificationDetails?.creationDate * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                        expiryDate: format(new Date(notificationData?.notificationDetails?.expiry * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                        payload: { ...notificationData?.notificationDetails },
                        msg: notificationData?.notificationDetails?.message?.payload,
                        copied:false,
                        action: (data) => (
                            <AppButton
                              variant="primary"
                              size="small"
                              onClick={() => {
                                setDialogContents({ title: "Notification Details", content: "notificationDetails", data })
                                openDialogSafely();
                                setDialogTab(0);
                              }}
                            >
                              View
                            </AppButton>
                        )

                    }]);
                    setShowNotificationList(true);
                    setIsSearching(false);
                } else {
                    setNotificationList([]);
                    setShowNotificationList(true);
                    setIsSearching(false);
                }
            }
            else if (
                notificationData?.lastAction?.includes("search_notification_failure") ||
                notificationData?.lastAction?.includes("get_notification_task_failure")
            ) {
                setNotificationList([]);
                setShowNotificationList(true);
                setIsSearching(false);
            }
            else if (notificationData?.lastAction?.includes("search_notification")) {
                const hasResults = Array.isArray(notificationData?.notificationDetails) && notificationData?.notificationDetails?.length > 0;
                if (hasResults) {
                    setNotificationList(notificationData?.notificationDetails?.map(n => {
                        return {
                            sentAt: format(new Date(n?.ts * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                            severity: n?.severity,
                            payload: { ...n },
                            fullUniqueId: n?.uniqueId,
                            uniqueId: <div title={n?.uniqueId}>
                                {
                                    "..." + n?.uniqueId?.substring(n?.uniqueId?.length - 6, n?.uniqueId?.length)
                                }
                            </div>,
                            msg: n?.message?.payload,
                            copied:false,
                            action: (data) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "start",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <AppIconButton
                                    variant="primary"
                                    size="small"
                                    icon={<VisibilityIcon fontSize="small" />}
                                    tooltip="View notification"
                                    onClick={() => {
                                      setDialogContents({
                                        title: "Notification Details",
                                        content: "userNotificationDetails",
                                        data,
                                      });
                                      openDialogSafely();
                                      setDialogTab(0);
                                    }}
                                  />
                                </Box>
                            )

                        }
                    }))
                    setShowNotificationList(true);
                    setIsSearching(false);
                } else {
                    setNotificationList([]);
                    setShowNotificationList(true);
                    setIsSearching(false);
                }
            }
            setTableHeaders(searchBy === "taskId" ? notificationStatusHeaders : notificationHeaders)
        }
    }, [notificationData?.lastAction])
    const handlePageChange = (newPage) => {
        const currentPage = pageIndex - 1;
        if (newPage > currentPage) {
            setIsSearching(true);
            getNextPage();
        } else if (newPage < currentPage) {
            setIsSearching(true);
            getPrevPage();
        }
    };

    const handlePageSizeChange = () => {
        // Page size is controlled via notificationListPageSize constant for now.
    };

    const notificationTableData = notificationList
      .map((element, index) => ({
        ...element,
        originalIndex: index,
        rowId:
          element?.fullTaskId ||
          element?.fullUniqueId ||
          `${pageIndex}-${index}`,
      }));
    const hasNotificationData = notificationTableData.length > 0;

    const notificationTableColumns = Object.keys(tableHeaders).map((key) => ({
      key,
      label: tableHeaders[key]?.label,
      align:
        tableHeaders[key]?.style?.justifyContent === "center"
          ? "center"
          : tableHeaders[key]?.style?.justifyContent === "flex-end"
            ? "right"
            : "left",
      justifyContent: tableHeaders[key]?.style?.justifyContent,
      width: key === "action" ? 110 : undefined,
      minWidth: key === "action" ? 110 : undefined,
      headerCellSx: {
        backgroundColor: "background.paper",
      },
      cellSx: {
        textAlign:
          tableHeaders[key]?.style?.justifyContent === "center"
            ? "center"
            : undefined,
      },
      render: (value, row) => {
        const cellValue =
          row?.hasOwnProperty(key)
            ? typeof row[key] === "function"
              ? row[key](row)
              : row[key]
            : "-";
        const isLong = String(cellValue).length > 200;

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent:
                tableHeaders[key]?.style?.justifyContent === "center"
                  ? "center"
                  : key === "action" || tableHeaders[key]?.style?.justifyContent === "flex-end"
                    ? "flex-end"
                  : "flex-start",
              gap: 1,
              width: "100%",
              whiteSpace: isLong ? "normal" : "nowrap",
              wordBreak: isLong ? "break-word" : "normal",
            }}
          >
            {cellValue}
            {(key === "taskId" || key === "uniqueId") && (
              <AppIconButton
                size="small"
                variant="ghost"
                tooltip="Copy"
                onClick={() => {
                  setNotificationList(notificationList?.map((n, i) => {
                    if (i === row.originalIndex) {
                      n.copied = true;
                    }
                    return n;
                  }));
                  setTimeout(() => {
                    setNotificationList(notificationList?.map((n, i) => {
                      if (i === row.originalIndex) {
                        n.copied = false;
                      }
                      return n;
                    }));
                  }, 3000);
                  navigator?.clipboard?.writeText(row?.fullTaskId || row?.fullUniqueId);
                }}
                icon={row?.copied ? <CheckCircleOutlineIcon /> : <FileCopyIcon />}
              />
            )}
          </Box>
        );
      },
    }));

    return (
        <Fragment>
            <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                <Paper sx={searchCardSx}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", lg: "auto 1fr" },
                      rowGap: 2,
                      columnGap: { xs: 2, lg: "116px" },
                      alignItems: "center",
                    }}
                  >
                    <SectionHeading sx={{ mb: 0 }}>
                      Search Notification
                    </SectionHeading>
                    <Box
                      component="form"
                      onSubmit={onSubmit}
                      sx={{
                        display: "grid",
                        gap: 1.5,
                        alignItems: "center",
                        width: "100%",
                        gridTemplateColumns: {
                          xs: "1fr",
                          sm: "90px minmax(160px, 200px) minmax(180px, 1fr) auto",
                          lg: "90px 200px minmax(220px, 320px) 100px",
                        },
                        justifyContent: "start",
                      }}
                    >
                      <SearchSectionLabel>Search By</SearchSectionLabel>
                      <FormInput
                        type="select"
                        size="small"
                        fullWidth
                        name="searchBy"
                        value={searchBy}
                        onChange={(e) => {
                          setSearchStr("");
                          setShowNotificationList(false);
                          setSearchBy(e?.target?.value);
                        }}
                        options={searchOptions?.map((o) => ({
                          value: o?.value,
                          label: o?.label,
                        })) || []}
                        MenuProps={selectMenuProps}
                        sx={{
                          width: { xs: "100%", md: "auto" },
                          minWidth: { xs: "100%", md: 200 },
                          maxWidth: { xs: "100%", md: 200 },
                          ...focusOutlineSx,
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "stretch",
                          gap: 0,
                          flexWrap: "nowrap",
                          width: "100%",
                          minWidth: 0,
                          overflow: "visible",
                          "&:focus-within .user-search-phone-wrap .react-tel-input .flag-dropdown": {
                            border: `1px solid ${primaryColor} !important`,
                          },
                          "&:focus-within .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "1px !important",
                          },
                        }}
                      >
                        {searchBy !== "taskId" ? (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "stretch",
                              flex: "1 1 auto",
                              minWidth: 0,
                              width: "100%",
                              maxWidth: "100%",
                              overflow: "visible",
                            }}
                          >
                            {searchBy === "mobile" && (
                              <Box className="user-search-phone-wrap" sx={phoneInputSx}>
                                <PhoneInput
                                  enableSearch={false}
                                  value={countryCode}
                                  onChange={setCountryCode}
                                  onlyCountries={allowedCountries}
                                />
                              </Box>
                            )}
                            <FormInput
                              fullWidth
                              size="small"
                              placeholder={searchOptions?.find(o => o?.value === searchBy)?.placeholder}
                              type={searchBy === "mobile" ? "text" : "text"}
                              inputProps={{ inputMode: searchBy === "mobile" ? "numeric" : undefined }}
                              name="text"
                              value={searchStr}
                              onChange={(e) => {
                                setSearchStr(e?.target?.value)
                                setShowNotificationList(false)
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  onSubmit(e);
                                }
                              }}
                              startAdornment={searchBy === "mobile" ? null : <SearchIcon fontSize="small" />}
                              sx={{
                                minWidth: 0,
                                width: "100%",
                                margin: 0,
                                alignSelf: "stretch",
                                "& .MuiOutlinedInput-root": {
                                  height: searchInputHeight,
                                  marginTop: 0,
                                  minHeight: searchInputHeight,
                                  maxHeight: searchInputHeight,
                                  position: "relative",
                                  zIndex: 1,
                                  borderTopLeftRadius: searchBy === "mobile" ? "0 !important" : undefined,
                                  borderBottomLeftRadius: searchBy === "mobile" ? "0 !important" : undefined,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: defaultBorderColor,
                                  borderLeft: searchBy === "mobile" ? "none !important" : undefined,
                                  borderWidth: "1px",
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                  borderWidth: "1px !important",
                                },
                                "& .MuiInputBase-input": {
                                  height: `${searchInputHeight}px !important`,
                                  boxSizing: "border-box",
                                },
                                ...focusOutlineSx,
                              }}
                            />
                          </Box>
                        ) : (
                          <FormInput
                            type="text"
                            size="small"
                            fullWidth
                            name="taskId"
                            placeholder="Enter Task ID"
                            value={taskId?.textValue || ""}
                            onChange={(e) => {
                              const value = e.target.value || "";
                              setTaskId({ value, textValue: value });
                              setShowNotificationList(false);
                            }}
                            startAdornment={<SearchIcon fontSize="small" />}
                            sx={{
                              flex: "1 1 280px",
                              minWidth: 0,
                              ...focusOutlineSx,
                            }}
                          />
                        )}
                      </Box>
                      <AppButton
                        type="submit"
                        variant="primary"
                        size="medium"
                        sx={{
                          height: searchInputHeight,
                          width: { xs: "100%", md: "auto" },
                          justifySelf: { xs: "start", md: "start" },
                          minWidth: 100,
                        }}
                      >
                        Search
                      </AppButton>
                    </Box>
                  </Box>
                </Paper>
                <Alert />
                {showNotificationList && (
                    <Paper sx={{ ...resultsCardSx, mt: 2 }}>
                        {isSearching ? (
                          <ScreenLoader message="Fetching notifications..." />
                        ) : !hasNotificationData ? (
                          <EmptyState
                            message="No Data found"
                            sx={{ bgcolor: "transparent", p: 0 }}
                          />
                        ) : (
                          <>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: 1.5,
                                mb: 2,
                                minWidth: 0,
                                width: "100%",
                                overflow: "visible",
                              }}
                            >
                                {searchBy === "taskId" ? (
                                  getNotificationPermission(userRoles, "cancelNotification") && (
                                    <AppButton
                                      variant="danger"
                                      size="medium"
                                      disabled={notificationList[0]?.taskStatus === "cancelled" || !notificationList[0]?.hasOwnProperty("taskId")}
                                      onClick={() => {
                                        setDialogContents({ title: "Cancel Notification", content: "cancelNotification", data: notificationList[0] })
                                        openDialogSafely();
                                      }}
                                    >
                                      Cancel Notification
                                    </AppButton>
                                  )
                                ) : (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: { xs: "column", sm: "row" },
                                      alignItems: { xs: "stretch", sm: "center" },
                                      ml: "auto",
                                      gap: 1,
                                      minWidth: 0,
                                      width: { xs: "100%", sm: "auto" },
                                    }}
                                  >
                                    <LabelText noWrap={false} strong>
                                      Filter By Severity
                                    </LabelText>
                                    <FormInput
                                      type="select"
                                      size="small"
                                      fullWidth={false}
                                      name="severityFilter"
                                      value={severityFilter ?? ""}
                                      onChange={(e) => {
                                        const v =
                                          e?.target?.value === "" || e?.target?.value === "None"
                                            ? null
                                            : e?.target?.value;
                                        setSeverityFilter(v);
                                        setPageIndex(1);
                                        setIsSearching(true);
                                        searchNotificationData(1, v);
                                      }}
                                      options={severityOptions.map((o) => ({
                                        value: o.value ?? "",
                                        label: o.label,
                                      }))}
                                      displayEmpty
                                      renderValue={(v) =>
                                        v == null || v === ""
                                          ? "None"
                                          : severityOptions?.find((o) => o?.value === v)?.label || v
                                      }
                                      MenuProps={selectMenuProps}
                                      sx={{
                                        width: { xs: "100%", sm: 220 },
                                        flexShrink: 0,
                                        ...focusOutlineSx,
                                      }}
                                    />
                                  </Box>
                                )}
                            </Box>
                            <DataTable
                              columns={notificationTableColumns}
                              data={notificationTableData}
                              rowKey="rowId"
                              maxHeight="58vh"
                              minWidth="100%"
                              tableContainerSx={{
                                boxShadow: "none",
                                borderRadius: 0,
                              }}
                              msgForDisplay="No Data found"
                            />
                            {searchBy !== "taskId" && (
                              <IncrementalPagination
                                page={pageIndex - 1}
                                pageSize={notificationListPageSize}
                                dataLength={notificationList.length}
                                onPageChange={handlePageChange}
                                onPageSizeChange={handlePageSizeChange}
                                pageSizeOptions={[notificationListPageSize]}
                                isLastPage={notificationList.length < notificationListPageSize}
                                sx={{ m: 0, mt: 1.5, px: 0 }}
                              />
                            )}
                          </>
                        )}
                    </Paper>
                )}
            </Box>
        </Fragment>
    );
};

export default FindNotification;
